module.exports = __webpack_public_path__ + "static/media/platform-design.f7c4fe92.jpg";